/* eslint-disable no-underscore-dangle */
import { useFragment, graphql } from 'react-relay';
import Icon from '@/core/icon.js';
import { ORImageSpace as Image } from '@/core/image.js';
import { useTranslation } from '@/helpers/translate';

const query = graphql`
  fragment cardSkin1_item on Space
  @argumentDefinitions(lang: { type: "String!" }) {
    title(lang: $lang)
    rate
    reviewCounter
    urlByLang(lang: $lang)
    type
    description
    pictures(count: 1) {
      ...image_space_picture
    }
    dataByCategory {
      price {
        amount_excl_tax
      }
    }
  }
`;

function Skin1({ item, options = {} }) {
  const { t } = useTranslation();
  // console.log('Skin1 item:', item);
  if (!item) return null;
  // console.log('item', item);
  const classes = {
    lvl0: 'carousel-cell-space-home md:cursor-pointer',
  };

  if (options.lvl0) {
    classes.lvl0 = options.lvl0;
  }
  function getUrl() {
    return `${item.urlByLang}`;
  }

  function getImageProps() {
    return options.imageProps || {};
  }

  function truncateDescription(text) {
    if (!text) return '';
    const words = text.split(' ');
    return words.length > 60 ? words.slice(0, 60).join(' ') + '...' : text;
  }

  return (
    <a
      href={getUrl()}
      className={classes.lvl0}
      onClick={() => {
        window.location.href = getUrl();
      }}
    >
      <meta itemProp="mainEntity" content={item.title} />
      <meta itemProp="description" content={item.description} />
      <div className="absolute z-10 px-2 py-1 text-sm bg-white rounded top-4 left-4 text-purple-6">
        {!item?.dataByCategory?.price?.amount_excl_tax || <span className="font-medium" itemProp="price" content={item?.dataByCategory?.price?.amount_excl_tax}>{item?.dataByCategory?.price?.amount_excl_tax}</span>}
        <span className="text-purple-5/70" itemProp="priceCurrency" content="EUR">€ par jour</span>
        <meta itemProp="priceValidUntil" content="2025-12-31" />
      </div>
      <div className="block rounded-xl w-full h-[280px] bg-purple-0 overflow-hidden relative">

        {!item?.pictures?.length || (
          <Image
            {...getImageProps()}
            key={item.pictures[0].__id}
            defaultAlt={item.title}
            cardsSpaces
            picture={item.pictures[0]}
          />
        )}

      </div>
      <div className="pt-2 overflow-hidden text-sm text-purple-5">
        <h3 className="font-medium">{item.title}</h3>
        <p className="pt-1 text-xs leading-4 text-purple-5/50 line-clamp-3">{truncateDescription(item.description)}</p>
      </div>
      <div className="flex items-center justify-between">
        {!item.reviewCounter || (
          <div className="flex items-center">
            {!item.rate || (
              <Icon name="star" className="w-3 fill-current text-purple" />
            )}
            <span className="mx-1 text-sm text-purple">{item.rate}</span>
            <span className="text-sm text-dark">
              (
              {t('review:count_review', { count: item.reviewCounter })}
              )
            </span>
          </div>
        )}
      </div>
    </a>
  );
}

export { query, Skin1 };

export default function RootComponent({ item: itemData, ...props }) {
  const item = itemData?.__id ? useFragment(query, itemData || null) : itemData;

  return <Skin1 {...{ item }} {...props} />;
}
